module.exports = __webpack_public_path__ + "img/pad_img.e604ea9f.png";